/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */
// 倒计时
function getRandomNum(min, max) {
  return Math.floor(Math.random() * (max - min)) + min;
}

let endTimeG;

function cutDownTime() {
  let nowTime = new Date();
  let endTime = new Date(endTimeG);

  let leftTime = endTime.getTime() - nowTime.getTime();
  if (leftTime < 0) {
    setupNewCountdown();
    leftTime = 0;
  }
  let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
    leftM = Math.floor((leftTime / (1000 * 60)) % 60),
    leftS = Math.floor((leftTime / 1000) % 60);
  leftH = leftH >= 10 ? leftH : "0" + leftH;
  leftM = leftM >= 10 ? leftM : "0" + leftM;
  leftS = leftS >= 10 ? leftS : "0" + leftS;

  return {
    hour: leftH,
    minute: leftM,
    second: leftS,
  };
}
function setupNewCountdown() {
  const randomHour = getRandomNum(1, 9);
  const currentTime = new Date();
  endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
}
let intervalId;

function getCutDownTime() {
  setupNewCountdown();
  if (intervalId) clearInterval(intervalId);
  intervalId = setInterval(function () {
    let cutDownTimeText = cutDownTime();
    $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
    $(".sp_top_cut_down .sp_left_view .sp_minute").html(cutDownTimeText.minute);
    $(".sp_top_cut_down .sp_left_view .sp_second").html(cutDownTimeText.second);
  }, 1000);
}

getCutDownTime();

let spImgList = [
  "https://cdn.shopify.com/s/files/1/0666/5089/8661/files/202409041-p1.png",
  "https://cdn.shopify.com/s/files/1/0666/5089/8661/files/202409041-p2.png",
  "https://cdn.shopify.com/s/files/1/0666/5089/8661/files/202409041-p3.png",
  "https://cdn.shopify.com/s/files/1/0666/5089/8661/files/202409041-p4.png",
  "https://cdn.shopify.com/s/files/1/0666/5089/8661/files/202409041-p5.png",
  "https://cdn.shopify.com/s/files/1/0666/5089/8661/files/202409041-img4-1.png",
  "https://cdn.shopify.com/s/files/1/0666/5089/8661/files/202409041-img4-2.png",
  "https://cdn.shopify.com/s/files/1/0666/5089/8661/files/202409041-img4-3.png",
  "https://cdn.shopify.com/s/files/1/0666/5089/8661/files/202409041-img4-4.png",
  "https://cdn.shopify.com/s/files/1/0666/5089/8661/files/202409041-img4-5.png",
  "https://cdn.shopify.com/s/files/1/0666/5089/8661/files/202409041-c1.png",
  "https://cdn.shopify.com/s/files/1/0666/5089/8661/files/202409041-c2.png",
  "https://cdn.shopify.com/s/files/1/0666/5089/8661/files/202409041-c3.png",
  "https://cdn.shopify.com/s/files/1/0666/5089/8661/files/202409041-c4.png",
  "https://cdn.shopify.com/s/files/1/0666/5089/8661/files/20240907-img1.png",
  "https://cdn.shopify.com/s/files/1/0666/5089/8661/files/20240907-img2.png",
  "https://cdn.shopify.com/s/files/1/0666/5089/8661/files/20240907-img3.png",
];
let spImgList2 = [
  "https://cdn.shopify.com/s/files/1/0666/5089/8661/files/202409041-p1.png",
  "https://cdn.shopify.com/s/files/1/0666/5089/8661/files/20240907-img1.png",
  "https://cdn.shopify.com/s/files/1/0666/5089/8661/files/20240907-img2.png",
  "https://cdn.shopify.com/s/files/1/0666/5089/8661/files/20240907-img3.png",
]

function mainRender() {
  $(function () {
    $("#root").css("zoom", "normal");
    let scale = document.body.clientWidth / 1080;
    $("#root").css("zoom", scale);

    window.addEventListener(
      "resize",
      (function () {
        var timer;
        return function () {
          if (timer) clearTimeout(timer);
          timer = setTimeout(function () {
            $("#root").css("zoom", "normal");
            let scale = document.body.clientWidth / 1080;
            $("#root").css("zoom", scale);
          }, 100);
        };
      })()
    );
  });

  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
    const config = {
      rootMargin: "0px 0px 1300px 0px",
      threshold: 0,
    };

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target;
          const dataSrc = image.getAttribute("data-src");
          image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image); // 停止观察该图片
        }
      });
    },
    config);

    images.forEach(function (image) {
      lazyLoadObserver.observe(image); // 开始观察每个图片
    });
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach((subArray) => {
        subArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      });
    } else {
      // 处理一维数组
      imageArray.forEach((url) => {
        const img = new Image();
        img.src = url;
      });
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    lazyLoadImages();

    preloadImages(spImgList);

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]');
    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop;
        window.scroll({
          top:
            offsetTop * $("div#root").css("zoom") -
            258 * $("div#root").css("zoom"),
          behavior: "smooth", // 使用 smooth 实现平滑滚动
        }); // 方式二
      });
    });
  });

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  var isAndroid = /android/i.test(userAgent);
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log("Android");
  } else if (isIOS) {
    console.log("iOS");
  } else if (isPC) {
    console.log("PC");
  } else {
    $(".sp_system").css("letter-spacing", "-4px");
  }
}

mainRender();

let prods = window.product
function getCur(){
  let color = $('#sp-color div.active').attr('data-val')
  let size = $('#sp-size div.active').attr('data-val')
  return prods.filter(item=> item.option1 == color && item.option2 == size)[0]
}
function changePrice(){
  let num = 1
  let price = (getCur().price * num / 100).toFixed(2)
  let compare = (getCur().compare_at_price * num / 100).toFixed(2)
  // if(num == 1){
  //   price = (getCur().price * num / 100).toFixed(2)
  // }else if(num == 2){
  //   price = (getCur().price * num / 100 * 0.95).toFixed(2)
  // }else if(num == 3){
  //   price = (getCur().price * num / 100 * 0.9).toFixed(2)
  // }else {
  //   price = (getCur().price * num / 100 * 0.85).toFixed(2)
  // }
  // price = (price + '').replace('.', ',')
  // compare = (compare + '').replace('.', ',')
  $('#sp_price1').html(price)
  $('#sp_price2').html(compare)
  let off_font = 100 - Math.ceil(getCur().price / getCur().compare_at_price * 100)
  $(".product-part .sp-brand span").html(off_font);
}
$('.sp-btn-style').click(function(){
  window.location.href = '/cart/' + getCur().id + ':1'
})
$(".option").click(function () {
  $(this).siblings().removeClass("active");
  $(this).addClass("active");
  // style选项
  let colorOptions = $("#sp-color .option.active").index();
  $(".product-part .p-img")[0].src = spImgList[colorOptions];
  let sizeOptions = $("#sp-size .option.active").index();
  if(sizeOptions > 0){
    $(".product-part .p-img")[0].src = spImgList2[sizeOptions];
    $('.product-part .free_box').css('display', 'flex')
    $('.product-part .sp-pro').css('left', '256px')
    $('.product-part .sp-free').css('left', '150px')
    $('.product-part .sp-free').css('top', '550px')
  }else{
    $('.product-part .free_box').css('display', 'none')
    $('.product-part .sp-pro').css('left', '129px')
    $('.product-part .sp-free').css('left', '90px')
    $('.product-part .sp-free').css('top', '500px')
  }
  changePrice()
});
jQuery(".sp-scroll").slide({
  mainCell: ".nav-imgs",
  autoPlay: true,
  effect: "leftMarquee",
  interTime: 12,
  vis: 1,
  scroll: 2,
});

new Swiper("#sp-swiper1", {
  autoplay: true,
  autoplay: {
    disableOnInteraction: false,
  },
  spaceBetween: 30,
  slidesPerView: 1,
  loop: true,
  pagination: {
    el: ".sp-pagination1",
    type: "bullets",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-btn-next",
    prevEl: ".swiper-btn-prev",
  },
});
new Swiper("#sp-swiper2", {
  autoplay: true,
  autoplay: {
    disableOnInteraction: false,
  },
  spaceBetween: 10,
  slidesPerView: "auto",
  centeredSlides: true,
  loop: true,
  pagination: {
    el: ".sp-pagination2",
    type: "bullets",
    clickable: true,
  },
});
